export const RoleEnum = Object.freeze({
  ADMIN: "ADMIN",
  ANALYST: "ANALYST",
  BOARD: "BOARD",
  EXEC: "EXEC",
  MANAGER: "MANAGER",
  USER: "USER",
  VIEWER: "VIEWER",
});

export const normalizeRole = (value, fallback = "") => {
  if (!value) return fallback;
  return String(value).toUpperCase();
};

export const isRole = (value, role) => normalizeRole(value, "") === role;
export const hasRole = (value, roles) => roles.includes(normalizeRole(value, ""));
